module.exports = __webpack_public_path__ + "img/img-jili-d.789af48c.png";